export default "__VITE_ASSET__1b765248__"